// extracted by css-extract-rspack-plugin
export default {"base":"SelectCard__base--vPUjd","icon":"SelectCard__icon--V2Kzt","button":"SelectCard__button--vslaC","container":"SelectCard__container--knhgW"};